<template>
	<div class=" enterprisewebsite"  v-title :data-title="msg">
		<headerbar :curindex="curindex"></headerbar>
	 <div class="industrial-list">
			<div class="whitebox centerpage oh">
				<div class="w95mg"> 
			 <div class="floortitle-en mgbn">
			 	<h2 class="title">企业动态</h2>
			 </div>
				<div class="pro-indynalist">
					<div class="titlebox flexcss"> 
						<h5 :class="toipsbtn != 1?'title nocur':'title'" @click="toipsbtn=1">行业重点企业</h5> 
						<h5 :class="toipsbtn != 2?'title nocur':'title'" @click="toipsbtn=2">标杆企业</h5>
					</div>
					<div  v-show="toipsbtn == 1" class="pro_tablelist">  
						<table border="0" cellspacing="0" cellpadding="0">
							<tr><th>时间</th><th>公司</th><th>内容</th></tr>
							<tr v-for="item in pagedata[0].zdDynamic">
								<td>{{item.publishTime}}</td>
								<td :class="item.stockCode!=0?'a-router':''" @click="routerlinkid('/enterprises',item.stockCode)">{{substring(item.title)}}</td>
								<td @click="routerlinkid('/news',item.id)" class="a-router">{{item.title}}</td> 
							</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div>
					<div  v-show="toipsbtn == 2" class="pro_tablelist">
						<table border="0" cellspacing="0" cellpadding="0">
							<tr><th>时间</th><th>公司</th><th>内容</th></tr>
							<tr v-for="item in pagedata[0].bgDynamic">
								<td>{{item.publishTime}}</td>
								<td :class="item.stockCode!=0?'a-router':''" @click="routerlinkid('/enterprises',item.stockCode)">{{substring(item.title)}}</td>
								<td @click="routerlinkid('/news',item.id)" class="a-router">{{item.title}}</td>
									<!--<td>
								 <p v-show="item.good>0" :class="item.good==1?'stargrade1 redstargrade':'stargrade1 greenstargrade'" ><i v-for="tor in item.star"></i></p> -->
									<!-- <p class="stargrade1 stargrade" ><i class="starfull" v-for="tor in item.star"></i><i class="stargray" v-for="tor in 4-item.star"></i></p> 
								</td>-->
							</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div>
				</div> 
			</div> 
		</div>  
		<div class="whitebox centerpage oh">
			<div class="w95mg">
				<div class="floortitle-en bdbe">
					<h2 class="title">企业战略参考</h2> 
				</div>
				<div class="indexflex dynamiclist-ind">
					<div class="col4h">
						<h4 class="title">行业重点企业</h4>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="flextable"> 
							<tr v-for="list in pagedata[2].zdStrategy">
								<td style="padding-left: 20px;">{{list.publishTime}}</td>
								<td><span @click="routerlinkid('/news',list.id,3)" class="a-router">{{list.title}}</span></td>
								<td><span :class="list.stockCode!=0?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)">企业画像</span></td> 
							</tr> 
						</table>
						<span class="morelink">更多内容>></span>
					</div>
					<div class="col4h">
						<h4 class="title">标杆企业</h4>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="flextable">
							<tr v-for="list in pagedata[2].bgStrategy">
								<td style="padding-left: 20px;">{{list.publishTime}}</td> 
								<td><span @click="routerlinkid('/news',list.id,3)" class="a-router">{{list.title}}</span></td>
								<td><span :class="list.stockCode!=0?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)">企业画像</span></td> 
							</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div> 
				</div>  
			</div>
		</div>
		<div class="whitebox centerpage oh">
			<div class="w95mg">
				<div class="floortitle-en bdbe">
					<h2 class="title">商业模式借鉴</h2> 
				</div>
				<div class="indexflex dynamiclist-ind">
					<div class="col4h">
						<h4 class="title">行业重点企业</h4>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="flextable"> 
						<tr v-for="list in pagedata[1].zdMode">
						<td style="padding-left: 20px;">{{list.publishTime}}</td>
						<td><span @click="routerlinkid('/news',list.id,3)" class="a-router">{{list.title}}</span></td>
						<td><span :class="list.stockCode!=0?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)">企业画像</span></td> 
						</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div>
					<div class="col4h">
						<h4 class="title">标杆企业</h4>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="flextable">
							<tr v-for="list in pagedata[1].bgMode">
								<td style="padding-left: 20px;">{{list.publishTime}}</td>
								<td><span @click="routerlinkid('/news',list.id,3)" class="a-router">{{list.title}}</span></td>
								<td><span :class="list.stockCode!=0?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)">企业画像</span></td> 
							</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div> 
				</div>  
			</div>
		</div> 
		<div class="whitebox centerpage oh">
			<div class="w95mg">
				<div class="floortitle-en bdbe">
					<h2 class="title">标杆案例学习</h2> 
				</div>
				<div class="indexflex dynamiclist-ind">
					<div class="col4h">
						<h4 class="title">行业重点企业</h4>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="flextable"> 
						<tr v-for="list in pagedata[3].zdCase">
							<td style="padding-left: 20px;">{{list.publishTime}}</td>
							<td><span :class="list.stockCode!=0?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)">企业画像</span></td>
							<td><span @click="routerlinkid('/news',list.id,3)" class="a-router"><span @click="routerlinkid('/news',list.id,3)" class="a-router">{{list.title}}</span></span></td> 
						</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div>
					<div class="col4h">
						<h4 class="title">标杆企业</h4>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="flextable">
							<tr v-for="list in pagedata[3].bgCase">
								<td style="padding-left: 20px;">{{list.publishTime}}</td>
								<td><span @click="routerlinkid('/news',list.id,3)" class="a-router">{{list.title}}</span></td>
								<td><span :class="list.stockCode!=0?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)">企业画像</span></td> 
							</tr>
						</table>
						<span class="morelink">更多内容>></span>
					</div> 
				</div>  
			</div>
		</div>
		<div class="whitebox centerpage oh" v-show="shifanproject.length>0">
			<div class="w95mg">
				<div class="floortitle-en bdbe">
					<h2 class="title">示范项目</h2> 
				</div>
				<div class="dynamiclist-ind enterprise_table"> 
				  <table  border="0" cellspacing="0" cellpadding="0" width="100%">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>项目名称</th>
								<th>企业名称</th>
								<th>概念</th>
							</tr>
							<tr v-for="(item,i) in shifanproject">
								<td>{{i+1}}</td>
								<td><span class="curp db" @click="routerlinkid('/news',item.id)">{{item.title}}</span></td>
								<td>
									<span v-if="item.stockCode" class="curp" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title.split('——')[1]}}</span>
									<span v-if="!item.stockCode">{{item.title.split('——')[1]}}</span>
								</td>
								<td>{{item.notion?item.notion:'-'}}</td>
							</tr>
						</table>
				</div>  
			</div>
		</div>
		</div> 
		<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
	  name: 'strategicList',
	  data(){return{
				msg:"战略管理",
				curindex:3,
				toipsbtn:1,
				pagedata:[{zdDynamic:[], bgDynamic:[]},{zdMode:[], bgMode:[]},{zdStrategy:[], bgStrategy:[]},{zdCase:[], bgCase:[]}], 
				userdata:{}, shifanproject:[],
			}},
			created() {  
				this.getuserinfor();
				var _this=this;
				this.$axios.get(this.$api.cyl.enterpriseEdition.strategy(),{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
					console.log(res.data.list);
					_this.pagedata=res.data.list;
					_this.bus.$emit('loading',false); 
				});
					this.$axios.get(this.$api.cyl.news.list()+"?reportType=29003&pageSize=20&notionList="+this.userdata.notion,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log(res.data.list);
						if(res.data.success){
							_this.shifanproject=res.data.list 
						}
					});
			},
			methods:{
				substring(title){
					var arr = title.replace(/：/g, ":").split(/[:_]/);
					// console.log(arr);
					if(arr.length > 1){
						return arr[0];
					}
					return title;
				},  
				//公用部分
				getuserinfor(){
					this.bus.$emit('loading',true); 
					let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
					if(typeof(dataddd) == 'object'){
					this.userdata = dataddd;
					}else{
					this.userdata = JSON.parse(dataddd);
					}  
				}, 
			}
	}
	
	
	
</script>

<style >
	
</style> 
